<template>
  <div class="bg-gray-100 px-6 py-12 md:p-20">
    <p class="pb-6 text-xl md:text-2xl font-serif">{{ $t('home.reviews.title') }}</p>
    <div class="pb-12">{{ $t('home.reviews.description') }}
    </div>
    <div class="rounded-lg overflow-hidden">
      <swiper-container ref="containerRef" :init="false">
        <swiper-slide
          class="bg-tau-red text-white flex flex-col justify-center items-center p-10 md:p-20 text-center gap-5 border border-gray-100"
          v-for="(review, idx) in reviews" :key="idx">
          <h3 data-aos="fade-bottom" data-aos-duration="700">{{ $t(`home.reviews.reviews[${idx}].name`) }}</h3>
          <p data-aos="zoom-in" data-aos-duration="700" class="h-32 flex items-center">"{{ $t(`home.reviews.reviews[${idx}].review`) }}"
          </p>
          <span>⭐️ {{ review.rating }}/5</span>
        </swiper-slide>
      </swiper-container>
    </div>
  </div>
</template>

<script setup>
const containerRef = ref(null)
const reviews = ref([
  { rating: 5 },
  { rating: 5 },
  { rating: 5 },
  { rating: 5 },
  { rating: 5 },
  { rating: 5 },
  { rating: 5 },
  { rating: 5 },
  { rating: 5 },
  { rating: 5 },
]);

const swiper = useSwiper(containerRef, {
  loop: false,
  pagination: true,
  slidesPerView: 1,
  autoplay: {
    delay: 5000
  },
  breakpoints: {
    1500: {
      slidesPerView: 3
    }
  }
});
</script>

<style>
:root {
  --swiper-pagination-color: #ffffff;
}
</style>